var FieldSet = {
  spacing: 'major-2'
};
export default FieldSet;